import { Routes } from "@angular/router";
import { HomeComponent } from "./pages/home/home.component";

export const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    title: "AdRadar – LinkedIn Ads AI Copilot for B2B Teams",
  },
  {
    path: "gdpr-compliance",
    loadComponent: () =>
      import("./pages/gdpr/gdpr.component").then((m) => m.GdprComponent),
    title: "GDPR Compliance | adRadar",
  },
  {
    path: "website-terms",
    loadComponent: () =>
      import("./pages/website-terms/website-terms.component").then(
        (m) => m.WebsiteTermsComponent,
      ),
    title: "Website Terms | adRadar",
  },
  {
    path: "website-privacy-policy",
    loadComponent: () =>
      import("./pages/website-privacy/website-privacy.component").then(
        (m) => m.WebsitePrivacyComponent,
      ),
    title: "Website Privacy Policy | adRadar",
  },
  {
    path: "platform-terms",
    loadComponent: () =>
      import("./pages/platform-terms/platform-terms.component").then(
        (m) => m.PlatformTermsComponent,
      ),
    title: "Platform Terms | adRadar",
  },
  {
    path: "platform-privacy-policy",
    loadComponent: () =>
      import("./pages/platform-privacy/platform-privacy.component").then(
        (m) => m.PlatformPrivacyComponent,
      ),
    title: "Platform Privacy Policy | adRadar",
  },
  {
    path: "security-policy",
    loadComponent: () =>
      import("./pages/security/security.component").then(
        (m) => m.SecurityComponent,
      ),
    title: "Security Policy | adRadar",
  },
  {
    path: "blog",
    loadComponent: () =>
      import("./pages/blog/blog-list-v2.component").then(
        (m) => m.BlogListV2Component,
      ),
    title: "Blog | adRadar",
  },
  {
    path: "blog-categories",
    loadComponent: () =>
      import("./pages/blog/blog-list.component").then(
        (m) => m.BlogListComponent,
      ),
    title: "Blog Categories | adRadar",
  },
  {
    path: "blog/:slug",
    loadComponent: () =>
      import("./pages/blog/blog-detail.component").then(
        (m) => m.BlogDetailComponent,
      ),
    title: "Blog Post | adRadar",
  },
  {
    path: "author/:slug",
    loadComponent: () =>
      import("./pages/blog/author.component").then((m) => m.AuthorComponent),
    title: "Author | adRadar Blog",
  },
  {
    path: "help-center",
    loadChildren: () =>
      import("./pages/help-center/help-center.routes").then(
        (m) => m.HELP_CENTER_ROUTES,
      ),
    title: "Help Center | adRadar",
  },
  {
    path: "agents/impression-capping-agent",
    loadComponent: () =>
      import("./pages/agents/impression-capping/impression-capping.component").then(
        (m) => m.ImpressionCappingComponent,
      ),
    title:
      "LinkedIn Impression Capping Agent | ABM Budget Distribution | AdRadar",
  },
  {
    path: "agents/title-blocking-agent",
    loadComponent: () =>
      import("./pages/agents/title-blocking/title-blocking.component").then(
        (m) => m.TitleBlockingComponent,
      ),
    title:
      "LinkedIn Title Blocking Agent | Job Title Targeting Precision | AdRadar",
  },
  {
    path: "agents/bidding-optimization-agent",
    loadComponent: () =>
      import("./pages/agents/bidding-optimization/bidding-optimization.component").then(
        (m) => m.BiddingOptimizationComponent,
      ),
    title: "LinkedIn Bid Optimization Agent | Recover Wasted Spend | AdRadar",
  },
  {
    path: "agents/campaign-scheduling-agent",
    loadComponent: () =>
      import("./pages/agents/campaign-scheduling/campaign-scheduling.component").then(
        (m) => m.CampaignSchedulingComponent,
      ),
    title: "LinkedIn Campaign Scheduling | Ads Dayparting Tool | AdRadar",
  },
  {
    path: "agents/company-blocking-agent",
    loadComponent: () =>
      import("./pages/agents/company-blocking/company-blocking.component").then(
        (m) => m.CompanyBlockingComponent,
      ),
    title:
      "LinkedIn Company Blocking Agent | ICP Targeting Enforcement | AdRadar",
  },
  {
    path: "agents/analyse-competitors-agent",
    loadComponent: () =>
      import("./pages/agents/analyse-competitors/analyse-competitors.component").then(
        (m) => m.AnalyseCompetitorsComponent,
      ),
    title: "LinkedIn Competitor Ads Intelligence | Monitor & Counter | AdRadar",
  },
  {
    path: "agents/ad-rotation-agent",
    loadComponent: () =>
      import("./pages/agents/ad-rotation/ad-rotation.component").then(
        (m) => m.AdRotationComponent,
      ),
    title: "LinkedIn Ad Rotation Agent | Detect Creative Fatigue | AdRadar",
  },
  {
    path: "pricing",
    loadComponent: () =>
      import("./pages/pricing/pricing.component").then(
        (m) => m.PricingPageComponent,
      ),
  },
  { path: "**", redirectTo: "" },
];
